"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.KEY_ROTATION_REQUIRED = exports.KEY_ALREADY_ROTATED = exports.ENCRYPTION_KEY_URL_MISMATCH = exports.DEFAULT_CLUSTER_SERVICE = exports.DEFAULT_CLUSTER = void 0;
var KEY_ROTATION_REQUIRED = 1400087;
exports.KEY_ROTATION_REQUIRED = KEY_ROTATION_REQUIRED;
var KEY_ALREADY_ROTATED = 1409004;
exports.KEY_ALREADY_ROTATED = KEY_ALREADY_ROTATED;
var ENCRYPTION_KEY_URL_MISMATCH = 1400049; // The default cluster when one is not provided (usually as 'US' from hydra)

exports.ENCRYPTION_KEY_URL_MISMATCH = ENCRYPTION_KEY_URL_MISMATCH;
var DEFAULT_CLUSTER = 'urn:TEAM:us-east-2_a'; // The default service name for convo (currently identityLookup due to some weird CSB issue)

exports.DEFAULT_CLUSTER = DEFAULT_CLUSTER;
var DEFAULT_CLUSTER_SERVICE = 'identityLookup';
exports.DEFAULT_CLUSTER_SERVICE = DEFAULT_CLUSTER_SERVICE;
//# sourceMappingURL=constants.js.map
